<template>
	<div class="detail-info-body">
		<div class="icon-box">
			<img src="~/images/icon/pendingReturn.png" v-if="refundStatus === '申请退货'" class="img">
			<img src="~/images/icon/rejectReturn.png" v-if="refundStatus === '拒绝退货'" class="img">
			<img src="~/images/icon/complet.png" v-if="refundStatus === '退货完成' ||refundStatus === '同意退货'" class="img">
		</div>
		<div class="info-box">
			<div class="info-row">
				<div class="info-row-item">
					退单状态：
					<span style="color: #FF7226;font-size: 15px;" v-if="refundStatus === '申请退货'">待处理</span>
					<span style="color: #3AB613;font-size: 15px;" v-if="refundStatus === '同意退货'">已同意</span>
					<span style="color: #666666;font-size: 15px;" v-if="refundStatus === '拒绝退货'">已拒绝</span>
					<span style="color: #3AB613;font-size: 15px;" v-if="refundStatus === '退货完成'">退货完成</span>
				</div>
				<div class="info-row-item">
					应退金额：<span style="color: #333333;font-weight: bold;">￥{{detailData.totalprice}}</span>
				</div>
				<div class="info-row-item">
					退货类型：{{detailData.autorefundflag===1?'自动退货':'手动退货'}}
				</div>
			</div>
			<div class="info-row">
				<div class="info-row-item">
					申请退单时间： {{createdate}}
				</div>
				<div class="info-row-item">
					退单编号： {{detailData.ordernumber}}
					<img
						src="~/images/icon/copy-icon.png"
						class="copy"
						v-clipboard:copy="detailData.ordernumber"
						v-clipboard:success="onCodeCopy"
						v-clipboard:error="onCodeError"/>

				</div>
				<div class="info-row-item">
					<div v-show='detailData.autorefundflag===1'>
						子订单状态来源：
						<span v-if="detailData.sourcetype === 3">待收货</span>
						<span v-if="detailData.sourcetype === 4">已完成</span>
					</div>
				</div>
			</div>
			<div class="info-row">
				<div class="info-row-item">
					退款方式： {{refundway}}
				</div>
				<div class="info-row-item">
					退款原因：{{refundReason1}}
				</div>
				<div class="info-row-item">

				</div>
			</div>
			<div class="info-row" style="height: 80px;">
				<div class="info-row-item">
					问题描述：
					<div style="flex: 1;height: 60px;padding: 5px; line-height: 20px;overflow-y: auto;background-color: #fbfbfb;">
						{{detailData.memo}}
					</div>
				</div>
				<div class="info-row-item">
					<div class="picture">
						<div  @click="certificateShow1"  v-for="( item , index ) in detailData.refundImgs" :key='index'>
							<w-image :src="item.ru_url"></w-image>
						</div>
					</div>
				</div>
			</div>
			<div class="btn-box1">
				<el-button size="small" v-if='showBtn3' @click='pullClick' type="primary">手动同步云数据</el-button>
			</div>
		</div>
		<el-dialog
			title="图片展示"
			:visible.sync="dialogVisible1"
			:close-on-click-modal="false"
			class="dialog-title"
			width="700px">
			<CertificateView :data='detailData.refundImgs'/>
		</el-dialog>
	</div>
</template>

<script>
import CertificateView from '@/components/refundOrderDetail/CertificateView.vue'

export default {
	name: 'detailInfo',
	components: {
		CertificateView
	},
	props: {
		detailData: Object,
		showBtn1: Boolean,
		showBtn2: Boolean,
		showBtn3: Boolean
	},
	data () {
		return {
			createdate: '',
			cancelcause: '',
			refundReason: '',
			refundReason1: '',
			refundStatus: '',
			payStatus: '',
			refundway: '',
			dialogVisible1: false,
			liquidateflag: 0
		}
	},
	watch: {
		detailData: {
			handler (val) {
				console.log(val)
				this.liquidateflag = val.liquidateflag
				switch (val.cause) {
				case 0:
					this.refundReason = '手动退单'
					this.refundReason1 = '无理由退换'
					break
				case 1:
					this.refundReason = '手动退单'
					this.refundReason1 = '质量问题'
					break
				case 2:
					this.refundReason = '手动退单'
					this.refundReason1 = '与商品描述不符合'
					break
				case 3:
					this.refundReason = '手动退单'
					this.refundReason1 = '卖家发错货'
					break
				case 4:
					this.refundReason = '手动退单'
					this.refundReason1 = '发票问题'
					break
				case 5:
					this.refundReason = '手动退单'
					this.refundReason1 = '其他'
					break
				case 6:
					this.refundReason = '实际发货差异退单'
					this.refundReason1 = '差异自动退货'
					break
				case 7:
					this.refundReason = '实际收货差异退单'
					this.refundReason1 = '差异自动退货'
					break
				}
				switch (val.cancelcause) {
				case 1:
					this.cancelcause = '质量无问题'
					break
				case 2:
					this.cancelcause = '超出退货时间'
					break
				case 3:
					this.cancelcause = '问题已解决'
					break
				case 4:
					this.cancelcause = '该商品不符合无理由退货'
					break
				case 5:
					this.cancelcause = '影响二次销售'
					break
				default:
					this.cancelcause = val.othercause === '' ? '其他原因' : val.othercause
					break
				}
				switch (val.orderstatus) {
				case 0:
					this.refundStatus = '申请退货'
					break
				case 1:
					this.refundStatus = '同意退货'
					break
				case 2:
					this.refundStatus = '拒绝退货'
					break
				case 3:
					this.refundStatus = '退货完成'
					break
				case 4:
					this.refundStatus = '仲裁中'
					// this.refundStatus = '退货处理'
					break
				}
				switch (val.refundstatus) {
				case 0:
					this.payStatus = '未退款'
					break
				case 1:
					this.payStatus = '已退款'
					break
				case 2:
					this.payStatus = '退款中'
					break
				case 3:
					this.payStatus = '退款失败'
					break
				}
				switch (val.refundway) {
				case 0:
					this.refundway = '线下'
					break
				case 1:
					this.refundway = '商龙钱包'
					break
				case 2:
					this.refundway = '微信支付'
					break
				case 3:
					this.refundway = '支付宝'
					break
				case 4:
					this.refundway = '预付货款'
					break
				}
				this.createdate = this.formatTime(val.createdate, 'Y/M/D h:m:s')
			},
			immediate: true
		}
	},
	methods: {
		reject () {
			this.$parent.reject()
		},
		btnClick (data) {
			this.$parent.btnClick(data)
		},
		pullClick () {
			this.$parent.pullClick()
		},
		checkStatus () {
			let params = {
				orderId: this.detailData.orderId,
				refundId: this.detailData.refundId,
				refundPayId: this.detailData.refundPayId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/status`,
				data: params
			}).then(res => {
				if (res.result) {
					switch (res.data) {
					case 0:
						this.payStatus = '未退款'
						break
					case 1:
						this.payStatus = '已退款'
						break
					case 2:
						this.payStatus = '退款中'
						break
					case 3:
						this.payStatus = '退款失败'
						break
					}
				}
			})
		},
		onCodeCopy (e) {
			this.$message.success('复制成功！')
		},
		onCodeError (e) {
			this.$message.error('复制失败！')
		},
		formatTime (number, format) {
			var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
			var returnArr = []

			var date = new Date(number)
			returnArr.push(date.getFullYear())
			returnArr.push(this.formatNumber(date.getMonth() + 1))
			returnArr.push(this.formatNumber(date.getDate()))

			returnArr.push(this.formatNumber(date.getHours()))
			returnArr.push(this.formatNumber(date.getMinutes()))
			returnArr.push(this.formatNumber(date.getSeconds()))

			for (var i in returnArr) {
				format = format.replace(formateArr[i], returnArr[i])
			}
			return format
		},
		formatNumber (n) {
			n = n.toString()
			return n[1] ? n : '0' + n
		},
		certificateShow1 () {
			this.dialogVisible1 = true
		}
	}
}
</script>

<style lang="stylus" scoped>
.detail-info-body {
	display: flex
	flex-direction:row;
	border :1px solid #DCE2FD;
	border-radius :4px;
	background-color :#F8FCFF;
	font-size: 14px;
	min-width :910px;
	padding:20px 10px 0px 10px;
	box-sizing :border-box
	.icon-box{
		width :80px;
		display :flex;
		justify-content:center
		.img{
			width:50px;
			height:50px;
		}
	}
	.picture{
		box-sizing :border-box;
		margin-left :20px;
		div {
			display inline-block
			width: 80px
			height: 80px
			cursor: pointer
			position: relative
			&:nth-of-type(2) {
				margin 0 10px
			}
			img {
				position: absolute
				max-height: 80px
				max-width: 80px
				top: 50%
				left: 50%
				transform: translate(-50%, -50%)
			}
		}
	}
	.info-box{
		display :flex;
		flex-direction :column;
		flex:1;
		.info-row{
			display :flex;
			flex-direction :row;
			height: 36px;
			align-items: center;
			.info-row-item{
				flex:1;
				color :#666666;
				display: flex;
				flex-direction: row;
				text-align :left
			}
		}
		.btn-box1{
			display flex;
			flex-direction:row;
			margin:5px 0px 15px 0px;
			.btn{
				width:100px;
			}
		}
	}
}
</style>
<style lang="stylus">
.detail-info-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
